import textPageLoginENG from './pages/login/ENG.json'
import textButtonENG from './pages/button/ENG.json'
import textHeaderENG from './pages/header/ENG.json'
import textRoomENG from './pages/room/ENG.json'
import textAdvanceSearchENG from './pages/advanceSearch/ENG.json'
import textLocationENG from './pages/location/ENG.json'
import textUserENG from './pages/user/ENG.json'
import textRoleENG from './pages/role/ENG.json'
import textProfileENG from './pages/profile/ENG.json'
import textBGENG from './pages/bg/ENG.json'
import textFacNFoodENG from './pages/facNfood/ENG.json'
import textIOTENG from './pages/iot/ENG.json'
import textEventENG from './pages/event/ENG.json'
import textOrderENG from './pages/order/ENG.json'
import textSettingENG from './pages/setting/ENG.json'
import textReportENG from './pages/report/ENG.json'
import textMonitorENG from './pages/Monitor/ENG.json'
import textValidate from './pages/validate/ENG.json'
import textModal from './pages/modal/ENG.json'
import textError from './pages/error/ENG.json'
import textIntegration from './pages/integration/EN.json'

export default {
    login: {
        ...textPageLoginENG
    },
    button: {
        ...textButtonENG
    },
    header: {
        ...textHeaderENG
    },
    room: {
        ...textRoomENG
    },
    advanceSearch: {
        ...textAdvanceSearchENG
    },
    location: {
        ...textLocationENG
    },
    user: {
        ...textUserENG
    },
    role: {
        ...textRoleENG
    },
    profile: {
        ...textProfileENG
    },
    bg: {
        ...textBGENG
    },
    facNfood: {
        ...textFacNFoodENG
    },
    iot: {
        ...textIOTENG
    },
    event: {
        ...textEventENG
    },
    order: {
        ...textOrderENG
    },
    setting: {
        ...textSettingENG
    },
    report: {
        ...textReportENG
    },
    monitor: {
        ...textMonitorENG
    },
    validate: {
        ...textValidate
    },
    modal: {
        ...textModal
    },
    error: {
        ...textError
    },
    integration: {
        ...textIntegration
    },
    noResult: "No Result",
    logo: "Devices Logo",
    home: "Home",
    name: "Name",
    fileSize: "File Size Limit = 10 MB",
    selectAll: "Select All",
    takePhoto: "Take Photo",
    uploadPhoto: "Upload Photo",
    deletePhoto: "Delete Photo"
}


// WEBPACK FOOTER //
// ./src/wording/en.js